import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="descripcion-imagen"
export default class extends Controller {
  static targets = ["select", "text", "modality"]

  connect() {
    this.selectTarget.addEventListener("mousedown", this.toggleOption)
    this.update()
  }

  update() {
    const modality = this.modalityTarget.value

    if (modality) {
      this.enableSelect(modality)
    }
  }

  toggleOption = (event) => {
    event.preventDefault()

    const option = event.target
    if (option.tagName !== "OPTION") return

    option.selected = !option.selected
  }

  enableFreeText() {
    this.selectTarget.classList.add("d-none")
    this.textTarget.classList.remove("d-none")

    Array.from(this.selectTarget.options).forEach(opt => opt.selected = false)
  }

  enableSelect(modality) {
    this.textTarget.classList.add("d-none")
    this.selectTarget.classList.remove("d-none")

    const selectedIds = this.selectedIds()

    fetch(`/descripciones_imagenes?modality=${encodeURIComponent(modality)}`)
      .then(response => response.json())
      .then(data => {
        this.selectTarget.innerHTML = ""

        data.forEach(item => {
          const option = document.createElement("option")
          option.value = item.id
          option.textContent = item.study

          if (selectedIds.includes(item.id)) {
            option.selected = true
          }

          this.selectTarget.appendChild(option)
        })
      })
  }

  selectedIds() {
    try {
      return JSON.parse(this.selectTarget.dataset.selectedIds || "[]")
        .map(id => Number(id))
    } catch {
      return []
    }
  }
}
